// extracted by mini-css-extract-plugin
export default {"rectangle":"slider_rectangle__JApMo","box":"slider_box__HI+SX","arrow":"slider_arrow__MuZ1v","values":"slider_values__6+K-4"};